/**
 * Core Modules Index
 */

// Utilities
import debug from 'debug';

const MODULE_NAME = 'app.core/modules';
const log = debug(MODULE_NAME);

import * as licencePing from './licence-ping';
import * as sticky from './sticky';
import * as smoothScroll from './smooth-scroll';
import * as toggleClass from './toggle-class';
import * as toggleDisable from './toggle-disable';
import * as navigation from './navigation';
import * as sliders from './sliders';
import * as breadcrumbs from './breadcrumbs';
import * as forms from './forms';
import * as customSelect from './custom-select';
import * as transportElements from './transport-elements';
import * as videoBlocks from './video-blocks';
import * as acceptCookie from './accept-cookie';
import * as ajaxValidate from './ajax-validate';
import * as ajaxInPlace from './ajax-in-place';
import * as disableOnSubmit from './disable-on-submit';
import * as addToQuote from './quote';
import * as ajaxSaveOnChange from './ajax-save-on-change';
import * as ajaxSaveOnCheck from './ajax-save-on-check';
import * as countryModal from './country-modal';
import * as countrySelect from './country-select';
import * as stickyNavigation from './sticky-navigation';
import * as toggleOnDirty from './toggle-on-dirty';
import * as toggleIfValue from './toggle-if-value';
import * as analyticsTrigger from './analytics-trigger';
import * as commerceAnalyticsTrigger from './commerce-analytics-trigger';
import * as commerceAnalyticsImpressions from './commerce-analytics-impressions';
import * as syncValue from './sync-value';
import * as addressValidation from './address-validation';
import * as popWindow from './pop-window';
import * as fetchFieldDetail from './fetch-field-detail';
import * as scrollToFirstError from './scroll-to-first-error';
import * as sortableProducts from './sortable-products';
import * as payPalPayments from './paypal-payments';
import * as dismiss from './dismiss';
import * as accordionRadioToggle from './accordion-radio-toggle';
import * as removeSpaces from './remove-spaces';
import * as locationChange from './location-change';
import * as userNeedsModal from './user-needs-modal';
import * as customiseProduct from './customise-product';
import * as presubmitCheck from './presubmit-check/index--split';
import * as dateParam from './date-param';
import * as switchAttribute from './switch-attribute';
import * as fetchInPlace from './fetch-in-place';

// Export
function exec() {
	log('Running...');
	
	licencePing.exec();
	sticky.exec();
	smoothScroll.exec();
	navigation.exec();
	sliders.exec();
	breadcrumbs.exec();
	customSelect.exec();
	forms.exec();
	transportElements.exec();
	videoBlocks.exec();
	acceptCookie.exec();
	ajaxValidate.exec();
	ajaxInPlace.exec();
	disableOnSubmit.exec();
	countryModal.exec();
	addToQuote.exec();
	stickyNavigation.exec();
	countrySelect.exec();
	toggleOnDirty.exec();
	toggleIfValue.exec();
	ajaxSaveOnChange.exec();
	ajaxSaveOnCheck.exec();
	syncValue.exec();
	toggleDisable.exec();
	addressValidation.exec();
	popWindow.exec();
	fetchFieldDetail.exec();
	scrollToFirstError.exec();
	sortableProducts.exec();
	payPalPayments.exec();
	dismiss.exec();
	accordionRadioToggle.exec();
	removeSpaces.exec();
	locationChange.exec();
	userNeedsModal.exec();
	customiseProduct.exec();
	commerceAnalyticsImpressions.exec();
	presubmitCheck.exec();
	dateParam.exec();
	switchAttribute.exec();
	fetchInPlace.exec();


	//  keep this last - triggers events consumed by customSelect
	toggleClass.exec();
	analyticsTrigger.exec();
	commerceAnalyticsTrigger.exec();
}

export default {
	exec,
};



// WEBPACK FOOTER //
// ./client/src/core/modules/index.js